// 年表計算區。
export const getters = {
  // 輸入無效代號或 call API 伺服器失效，接收錯誤提示訊息。
  errorMessageWithReportYear: state => state.errorMessage,

  // ------------------ 年表三個表格主標題區格式 ------------------

  headlinesOfReportYear: (
    { reportYear: [{ stock_symbol: stockSymbol, company_name: companyName }] },
    { map2Character }
  ) => ({
    stockSymbol, // 股票代號
    companyName, // 公司名稱
    balanceSheetsYear: map2Character("balance_sheets"), // 資產負債表
    incomeStatementsYear: map2Character("income_statements"), // 綜合損益表
    cashFlowStatementsYear: map2Character("cash_flow_statements") // 現金流量表
  }),

  // ------------------ 資產負債表_年 ------------------

  // unpack 表格欄位基本資料。
  balanceSheetsYear: ({ reportYear: [{ year_balance_sheets }] }) =>
    year_balance_sheets,

  // 共用 rootGetters => fieldsOfYear。
  // 取得資產負債表_年 Period 期別標題與 labels 種類次標題。
  // fieldsOfBalanceSheetsYear: (
  //   state,
  //   { fieldsOfYear, balanceSheetsYear } // getters
  // ) => fieldsOfYear(balanceSheetsYear),

  // 併整 bootstrap-vue items 格式與標題英翻中 => formatOfReportYear。
  itemsOfBalanceSheetsYear: (
    state,
    { balanceSheetsYear, formatOfReportYear }
  ) => formatOfReportYear(balanceSheetsYear),

  // 共用 rootGetters => layerOfTableArea。
  // 取得標題欄位 order 階層排列。
  layerOfBalanceSheetsYear: (
    state,
    { itemsOfBalanceSheetsYear, layerOfTableArea }
  ) => layerOfTableArea(itemsOfBalanceSheetsYear),

  // ------------------ 綜合損益表_年 ------------------

  incomeStatementsYear: ({ reportYear: [{ year_income_statements }] }) =>
    year_income_statements,

  // fieldsOfIncomeStatementsYear: (
  //   state,
  //   { fieldsOfYear, incomeStatementsYear }
  // ) => fieldsOfYear(incomeStatementsYear),

  itemsOfIncomeStatementsYear: (
    state,
    { incomeStatementsYear, formatOfReportYear }
  ) => {
    const tableBaseData = formatOfReportYear(incomeStatementsYear);
    //欄位排順序，歸屬母公司淨利（損）、綜合損益歸屬母公司要在本期綜合損益總額下方，稅前息前淨利上方
    const newItem1Idx = tableBaseData.findIndex(item =>
      item.subTitle.includes("歸屬母公司淨利")
    );
    const newitem1 = tableBaseData.splice(newItem1Idx, 1)[0];
    const newItem2Idx = tableBaseData.findIndex(item =>
      item.subTitle.includes("綜合損益歸屬母公司")
    );
    const newitem2 = tableBaseData.splice(newItem2Idx, 1)[0];
    const insertItemIdx = tableBaseData.findIndex(
      item => item.subTitle === "稅前息前淨利"
    );
    tableBaseData.splice(insertItemIdx, 0, newitem1, newitem2);
    return tableBaseData;
  },

  // ------------------ 現金流量表_年 ------------------

  cashFlowStatementsYear: ({ reportYear: [{ year_cash_flow_statements }] }) =>
    year_cash_flow_statements,

  // fieldsOfCashFlowStatementsYear: (
  //   state,
  //   { fieldsOfYear, cashFlowStatementsYear }
  // ) => fieldsOfYear(cashFlowStatementsYear),

  itemsOfCashFlowStatementsYear: (
    state,
    { cashFlowStatementsYear, formatOfReportYear }
  ) => formatOfReportYear(cashFlowStatementsYear),

  layerOfCashFlowStatementsYear: (
    state,
    { itemsOfCashFlowStatementsYear, layerOfTableArea }
  ) => layerOfTableArea(itemsOfCashFlowStatementsYear),

  // ------------------ 複用格式轉換區 ------------------

  // 全區併整 bootstrap-vue table => items 支援格式和英翻中小標題。
  formatOfReportYear: (state, { map2Character }) => dataSets => {
    return (
      // 取出所有 key 名，以小標題序列作為基底所構成的陣列，拿取 (array.length) 當作每次迴圈總數基準值。
      Object.keys(dataSets.slice().shift())
        // 將 year 移除，主因橫列無需顯示 year 標題列。
        .filter(field => field !== "year")
        // 將返回與 array.length 一樣總數的物件數量。
        .map(field => {
          // dataSets 長度為 8，代表每次皆會跑完八筆物件資料 2019, 2018, ...。
          return dataSets.reduce((init, current) => {
            // 併整為一個物件，重複 key 名時，後覆蓋前，做為最終值。
            return {
              ...init,
              subTitle: map2Character(field),
              // { "2012": current["amortization_CFO"], "2013": current["amortization_CFO"],... }
              [current.year]: current[field] === null ? "NA" : current[field]
            };
          }, {});
        })
    );
  }
};

// Object.keys(dataSets.slice().shift())
// ["amortization_CFO", "cash_dividends_paids_CFF", "cash_flow_during_this_period", "cash_flow_from_fundraising", "cash_flow_from_investment_activities",......, "year"]

// dataSets 返回近八年，每個物件代表一個年度，物件包含所有品項 key 名。
// {year:2019, total_other_L_T_liab: 11831, treasury_stock: 0, ...}
// [{...},{...},{...},{...},{...},{...},{...},{...}]

// bootstrap-vue table => items 支援格式如下：
// [ { "2012": 506745, "2013": 597024, "2014": 762806, "2015": 843497, "2016": 947938, "2017": 977447, "2018": 1031474, "2019": 1069985, "subTitle": "營業收入淨額" }, { "2012": 262583, "2013": 316058, "2014": 385113, "2015": 433118, "2016": 473077, "2017": 482616, "2018": 533488, "2019": 577287, "subTitle": "營業成本" }, ...]
